import { useCallback } from 'react';
import { IEnrollment } from '../enrollments/common/types';

const useGetSelectedEnrollmentDetails = () => {
    const getSelectedEnrollmentDetails = useCallback((eId, enrollmentandenrolleedetails) => {
        let enrollments: IEnrollment[] = [];
        const enrollmentDataDtoListMap = enrollmentandenrolleedetails?.enrollmentDataDtoListMap;
        if (enrollmentDataDtoListMap) {
            for (let key in enrollmentDataDtoListMap) {
                enrollments = enrollmentDataDtoListMap[key];
                enrollments.sort((a: IEnrollment, b: IEnrollment) => {
                    return new Date(b.creationTimestamp).getTime() - new Date(a.creationTimestamp).getTime();
                }) || [];
            }
        }
        const selectedEnrollment = enrollments.find((enrollment: IEnrollment) => enrollment.enrollmentId === eId);
        return selectedEnrollment;
    }, []);

    return getSelectedEnrollmentDetails;
};

export default useGetSelectedEnrollmentDetails;
